import { render, staticRenderFns } from "./CustomContextMenu.vue?vue&type=template&id=457d2372&scoped=true"
import script from "./CustomContextMenu.vue?vue&type=script&lang=ts"
export * from "./CustomContextMenu.vue?vue&type=script&lang=ts"
import style0 from "./CustomContextMenu.vue?vue&type=style&index=0&id=457d2372&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457d2372",
  null
  
)

export default component.exports